import axios from "axios";
import { createBrowserHistory } from "history";
import { config } from "../config/appConfig";
import { store } from "../index";
import { logoutSuccess } from "../modules/user/redux/action";

let user = "";
const history = createBrowserHistory();

export const getLocalStorageUser = () => {
  return JSON.parse(localStorage.getItem("user"));
};
const ErrorCode = {
  unauthorized: 401,
  serverError: 500
};
export const globalApiHandler = (url, method, data) => {
  user = getLocalStorageUser();
  return new Promise((resolve, reject) => {
    axios({
      method: method,
      url: `${config.BASE_URL}${url}`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `${user.token_type} ${user.access_token}`
      },
      data: data
    })
      .then(response => {
        resolve(response);
      })
      .catch(err => {
        if (!!err.response) {
          if (err.response.status === ErrorCode.unauthorized) {
            refreshToken()
              .then(() => {
                globalApiHandler(url, method, data)
                  .then(response => {
                    resolve(response);
                  })
                  .catch(err => {
                    reject(err);
                  });
              })
              .catch(err => {
                reject(err);
              });
            return;
          }
          if (err.response.status === ErrorCode.serverError) {
            err.response.data.message = err.response.data.path.includes(
              "makePayment"
            )
              ? err.response.data.message
              : "Something Went Wrong";
          }
          reject(err.response);
        }
      });
  });
};

const refreshToken = () => {
  return new Promise((resolve, reject) => {
    let bodyFormData = new FormData();
    let tokenurl = `${config.BASE_URL}/oauth/token`;
    bodyFormData.append("grant_type", "refresh_token");
    bodyFormData.append("refresh_token", user.refresh_token);
    axios
      .post(tokenurl, bodyFormData, {
        headers: {
          "Content-Type": config.Content_Type,
          Authorization: `Basic ${config.Authorization_Token}`
        }
      })
      .then(response => {
        localStorage.setItem("user", JSON.stringify(response.data));
        resolve(true);
      })
      .catch(err => {
        localStorage.removeItem("user");
        history.push("/login");

        // localStorage.removeItem('userProfile')
        store.dispatch(logoutSuccess());
        reject(err);
      });
  });
};



// WEBPACK FOOTER //
// ./src/services/services.js